<script setup>
import { utilsUsuarios } from 'cifra-api-js';
import { computed } from 'vue';

const props = defineProps({
  usuario: { type: Object, required: true },
});

const iconos = computed(() => (
  utilsUsuarios.iconos(props.usuario)
));
</script>

<template>
  <!--No usamos v-tooltip porque es muy lento, usamos el de bootstrap -->
  <i
    v-for="icono in iconos"
    :key="icono.clases"
    data-toggle="tooltip"
    :title="$t(icono.i18n)"
    :class="icono.clases"
  ></i>
</template>
